<template>
  <div id="breadcrumb" class="breadcrumb" :style="`background-color: ${backgroundBread};`">
      <ul>
          <li v-for="(breadcrumb, idx) in breadcrumbList" :key="idx"
            @click="routeTo(idx, breadcrumb.bandBreadCrumbStep1)"
            :class="{'linked': !!breadcrumb.link, 'linkedForce': !!breadcrumb.linkClass, 'pointer': !!breadcrumb.bandBreadCrumbStep1}">
            {{ $tc("breadcrumb."+breadcrumb.name) }}
          </li>
      </ul>
  </div>
</template>

<script>
export default {
    name:"Breadcrumb",
    data() {
        return {
            breadcrumbList:[],
            backgroundBread: "#FFF"
        };
    },
    mounted() { this.updateList() },
    watch: { '$route' () { this.updateList() }},
    methods: {
        routeTo(pRouteTo, band = false){
            if(band) {
                this.$emit("breadCrumbStep1");
            } else if(this.breadcrumbList[pRouteTo].link) {
                this.$router.push({name: this.breadcrumbList[pRouteTo].link});
            }
        },
        updateList(){ this.breadcrumbList = this.$route.meta.breadcrumb }
    },
    created(){ this.backgroundBread = this.$store.getters.env.get('VUE_APP_BACKGROUND_BREADCRUMB'); }
}
</script>

<style scoped>
    .breadcrumb{
        padding: 15px;
    }
    ul{
        display: flex;
        justify-content: left;
        list-style-type: none;
        margin:0;
        padding: 0;
    }
    ul > li{
        display: flex;
        float: left;
        height: 10px;
        width: auto;
        font-weight: bold;
        font-size: 1em;
        cursor: default;
        align-items: center;
    }
    ul > li:not(:last-child)::after{
        content: '>';
        float: right;
        font-size: 1em;
        margin: 0 .5em;
        cursor: default;
    }
    .linked{
        cursor: pointer;
        font-size: 1em;
        font-weight: normal;
    }
    .linkedForce{
        font-size: 1em;
        font-weight: normal;
    }
    .pointer {
        cursor: pointer;
    }
</style>